import { Redirect, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../../actions/app'
import { useAppSelector } from '../../reducers'
import { getDashboards, getSelectedEstateId } from '../../reducers/app'
import AnyDashboard from './AnyDashboard'
import { Routes } from '../../constants'
import {
    DashboardEntry,
    DashboardIcon,
    DashboardLeftIcon,
    DashboardLink,
    Header,
    ListWrapper,
} from './ReportingDashboards.style'

function ReportingDashboards() {
    const dashboards = useAppSelector(getDashboards)
    const estate = useAppSelector(getSelectedEstateId)
    const { dashboard } = useParams<{ estate: string; dashboard?: string }>()
    const { t } = useTranslation()
    usePageTitle(t('reports'))

    if (dashboard) {
        const selectedDashboard = dashboards.find(({ id}) => dashboard === id)

        if (!selectedDashboard) {
            return <>Dashboard does not exist {dashboard}</>
        }

        return <AnyDashboard>{selectedDashboard}</AnyDashboard>
    }

    // If there's only one dashboard, directly navigate to that one
    if (dashboards.length === 1) {
        const { id: defaultDashboardId } = dashboards[0]
        const path = Routes.buildRoute(
            Routes.REPORTING_DASHBOARDS,
            { estate, dashboard: defaultDashboardId },
        )

        return (
            <Redirect to={path} />
        )
    }

    return (
        <>
            <Header>{t('reports')}</Header>
            <ListWrapper>
                {dashboards.map(
                    ({ id, name }) => (
                        <DashboardEntry>
                            <DashboardLink to={`./reporting/${id}`}>
                                <DashboardLeftIcon icon="chart-bar" />
                                <span style={{ flex: 2 }}>{name}</span>
                                <DashboardIcon icon="chevron-right" />
                            </DashboardLink>
                        </DashboardEntry>
                    )
                )}
            </ListWrapper>
        </>
    )
}

export default ReportingDashboards
